var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaintRoller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C4 2.89543 4.89543 2 6 2H14C15.1046 2 16 2.89543 16 4V4.25H19C19.9665 4.25 20.75 5.0335 20.75 6V8.32297C20.75 9.03855 20.3143 9.68204 19.6499 9.9478L10.9072 13.4449C10.8122 13.4829 10.75 13.5748 10.75 13.677V15H11C11.5523 15 12 15.4477 12 16V21C12 21.5523 11.5523 22 11 22H9C8.44772 22 8 21.5523 8 21V16C8 15.4477 8.44772 15 9 15H9.25V13.677C9.25 12.9615 9.68566 12.318 10.3501 12.0522L19.0928 8.55509C19.1878 8.51712 19.25 8.42519 19.25 8.32297V6C19.25 5.86193 19.1381 5.75 19 5.75H16V6C16 7.10457 15.1046 8 14 8H6C4.89543 8 4 7.10457 4 6V5.75C3.58579 5.75 3.25 5.41421 3.25 5C3.25 4.58579 3.58579 4.25 4 4.25V4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintRoller);
export default __webpack_public_path__ + "static/media/paint-roller.f62f09af038f550e75c12ac6980144ba.svg";
export { ForwardRef as ReactComponent };